import { LoadingState } from '@/entities/LoadingState';
import { MutationTree, ActionTree, GetterTree, Module, ActionContext } from 'vuex';
import { PartSearchService } from '@/services/part-search-service';
import { RootState } from '../rootState';
import removeNamespace from '../removeNamespace';
import { VinSearchResult } from '@/entities/vin-search/VinSearchResult';

const partSearchService = new PartSearchService();

const namespace = 'vinSearch';

export const VinSearchModuleTypes = {
    getters: {
        searchTerm: `${namespace}/searchTerm`,
        searchResultsLoadingState: `${namespace}/searchResultsLoadingState`,
        vinSearchResult: `${namespace}/vinSearchResult`,
    },
    mutations: {
        loadSearchResults: `${namespace}/loadSearchResults`,
        loadSearchResultsSuccess: `${namespace}/loadSearchResultsSuccess`,
        loadSearchResultsFail: `${namespace}/loadSearchResultsFail`,
        closeVinSearchResults: `${namespace}/closeVinSearchResults`,
    },
    actions: {
        loadSearchResults: `${namespace}/loadSearchResults`,
        closeVinSearchResults: `${namespace}/closeVinSearchResults`,
    },
};

const types = removeNamespace(namespace, VinSearchModuleTypes);

export interface VinSearchState {
    searchTerm: string | null;
    searchResultLoadingState: LoadingState;
    vinSearchResult: VinSearchResult | null;
}

const state: VinSearchState = {
    searchTerm: null,
    searchResultLoadingState: LoadingState.Indeterminate,
    vinSearchResult: null,
};

const mutations: MutationTree<VinSearchState> = {
    [types.mutations.loadSearchResults](currentState: VinSearchState, payload: string): void {
        currentState.searchResultLoadingState = LoadingState.Loading;
        currentState.searchTerm = payload;
    },
    [types.mutations.loadSearchResultsSuccess](currentState: VinSearchState, payload: VinSearchResult): void {
        currentState.vinSearchResult = payload;
        currentState.searchResultLoadingState = LoadingState.Loaded;
    },
    [types.mutations.loadSearchResultsFail](currentState: VinSearchState): void {
        currentState.searchTerm = null;
        currentState.vinSearchResult = null;
        currentState.searchResultLoadingState = LoadingState.Failed;
    },
    [types.mutations.closeVinSearchResults](currentState: VinSearchState): void {
        currentState.searchTerm = null;
        currentState.vinSearchResult = null;
        currentState.searchResultLoadingState = LoadingState.Indeterminate;
    },
};

const actions: ActionTree<VinSearchState, RootState> = {
    [types.actions.loadSearchResults](
        context: ActionContext<VinSearchState, RootState>,
        payload: { searchTerm: string }
    ): void {
        context.commit(types.mutations.loadSearchResults, payload.searchTerm);
        partSearchService
            .getVinSearchResult(payload.searchTerm)
            .then((response) => {
                context.commit(types.mutations.loadSearchResultsSuccess, response);
            })
            .catch((e) => {
                context.commit(types.mutations.loadSearchResultsFail);
            });
    },
    [types.actions.closeVinSearchResults](context: ActionContext<VinSearchState, RootState>): void {
        context.commit(types.mutations.closeVinSearchResults);
    },
};

const getters: GetterTree<VinSearchState, RootState> = {
    [types.getters.searchTerm]: (currentState) => {
        return currentState.searchTerm;
    },
    [types.getters.searchResultsLoadingState]: (currentState) => {
        return currentState.searchResultLoadingState;
    },
    [types.getters.vinSearchResult]: (currentState) => {
        return currentState.vinSearchResult;
    },
};

const module: Module<VinSearchState, RootState> = {
    state,
    mutations,
    actions,
    getters,
    namespaced: true,
};

export default module;
